<script>
import ServerSideDatatable from '../../ServerSideDatatable/index.vue'
import DatePicker from '../../inputs/DatePicker.vue'
import TextInput from '../../inputs/TextInput.vue'
import Selector  from '../../inputs/Selector.vue'
import axios from 'axios'

export default {
  props: {
    establecimientos: {
      type: Array,
      default: () => [],
    },
    tipos_citas: {
      type: Array,
      default: () => [],
    },
    estados: {
      type: Array,
      default: () => [],
    },
    fecha_inicio_inicial: {
      type: String,
      default: null,
    },
    fecha_termino_inicial: {
      type: String,
      default: null,
    },
    csv_action: {
      type: String,
      default: null,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ServerSideDatatable,
    DatePicker,
    TextInput,
    Selector,
  },
  data() {
    return {
      uuid: null,
      carga_id: null,
      fecha_inicio: this.fecha_inicio_inicial,
      fecha_termino: this.fecha_termino_inicial,
      documento_paciente: null,
      documento_profesional: null,
      nombre_profesional : null ,
      id_establecimiento: null,
      id_tipo_cita: null,
      id_estado: null,
      ids_horas_seleccionadas: [],
    }
  },
  computed: {
    tableHeaders() {
      return [
        { key: 'fecha_inicio', label: 'Fecha inicio', sortable: true, sort_key: 'hora_inicio' },
        { key: 'uuid', label: 'Código cita', sortable: true, sort_key: 'UUID' },
        { key: 'carga_id', label: 'Código carga', sortable: true, sort_key: 'carga_id' },
        { key: 'establecimiento', label: 'Establecimiento', sortable: true, sort_key: 'nombre_establecimiento' },
        { key: 'nombre_profesional', label: 'Profesional', sortable: true, sort_key: 'nombre_profesional' },
        { key: 'rut_profesional', label: 'Rut profesional', sortable: true, sort_key: 'rut_profesional' },
        { key: 'nombre_paciente', label: 'Paciente', sortable: true, sort_key: 'nombre_paciente' },
        { key: 'rut_paciente', label: 'Rut paciente', sortable: true, sort_key: 'rut_paciente' },
        { key: 'tipo_cita', label: 'Tipo cita', sortable: true, sort_key: 'nombre_tipo_cita' },
        { key: 'tipo_atencion', label: 'Tipo Atencion', sortable: true, sort_key: 'tipo_atencion' },
        { key: 'estado', label: 'Estado', sortable: true, sort_key: 'nombre_estado' },
      ]
    },
    fetchParams() {
      return {
        uuid: this.uuid,
        carga_id: this.carga_id,
        fecha_inicio: this.fecha_inicio,
        fecha_termino: this.fecha_termino,
        documento_paciente: this.documento_paciente,
        nombre_profesional : this.nombre_profesional,
        documento_profesional: this.documento_profesional,
        id_establecimiento: this.id_establecimiento,
        id_tipo_cita: this.id_tipo_cita,
        id_estado: this.id_estado, 
      }
    },
    establecimientos_options() {
      return this.establecimientos?.map(({ id, nombre }) => ({ id, label: nombre  })) ?? []
    },
    tipos_citas_options() {
      return this.tipos_citas?.map(({ id, nombre }) => ({ id, label: nombre  })) ?? []
    },
    estados_options() {
      return this.estados?.map(({ id, nombre }) => ({ id, label: nombre  })) ?? []
    },
  },
  methods: {
    can(permission) {
      if(!this.user) return false
      return this.user?.roles?.includes('ADM') || this.user.permissions?.includes(permission)
    },
    loadRows() {
      this.$refs.tableRef.startGetData()
    },
    handleBuscarClick() {
      this.loadRows()
    },
    handleAnularClick() {
      if(!this.ids_horas_seleccionadas.length) {
        this.$swal.fire({
            position: 'center',
            icon: 'info',
            title: 'Oops...',
            text: "Selecciona una o mas horas",
            showConfirmButton: true,
        });
        return
      }
      this.$swal.fire({
          title: '¿Seguro desea anular estas horas?',
          showDenyButton: true,
          confirmButtonText: 'Si',
          denyButtonText: `No`,
      }).then((result) => {
          if (result.isConfirmed) {
            this.anular()
          }
      })
    },
    anular() {
      const ids_horas = this.ids_horas_seleccionadas
      axios.post('horas/anular', {ids_horas})
        .then(response => {
          const { ids_horas_anuladas, ids_horas_no_anuladas } = response.data
          let mensaje = ''
          let titulo = ''
          let icono = ''
          if(ids_horas_anuladas.length === ids_horas.length) {
            icono = 'success'
            titulo = '¡Éxito!'
            mensaje = 'Todas las horas fueron anuladas'
          } else if(ids_horas_anuladas.length === 0) {
            icono = 'error'
            titulo = '¡Error!'
            mensaje = 'Ninguna hora fue anulada'
          } else {
            icono = 'warning'
            titulo = '¡Atención!'
            mensaje = `Se anularon las horas con código [${ids_horas_anuladas.join(', ')}]  
            y no se anularon las horas con código [${ids_horas_no_anuladas.join(', ')}]
            `
          }
          this.loadRows()
          this.$swal.fire({
            position: 'center',
            icon: icono,
            title: titulo,
            text: mensaje,
            showConfirmButton: true,
          });
      }).catch(error => {
          console.log(error);
      })      
    },
    handleEliminarClick() {
      if(!this.ids_horas_seleccionadas.length) {
        this.$swal.fire({
            position: 'center',
            icon: 'info',
            title: 'Oops...',
            text: "Selecciona una o mas horas",
            showConfirmButton: true,
        });
        return
      }
      this.$swal.fire({
          title: '¿Seguro desea eliminar estas horas?',
          showDenyButton: true,
          confirmButtonText: 'Si',
          denyButtonText: `No`,
      }).then((result) => {
          if (result.isConfirmed) {
            this.eliminar()
          }
      })
    },
    eliminar() {
      const ids_horas = this.ids_horas_seleccionadas
      axios.post('horas/eliminar', {ids_horas})
        .then(response => {
          const { ids_horas_eliminadas, ids_horas_no_eliminadas } = response.data
          let mensaje = ''
          let titulo = ''
          let icono = ''
          if(ids_horas_eliminadas.length === ids_horas.length) {
            icono = 'success'
            titulo = '¡Éxito!'
            mensaje = 'Todas las horas fueron eliminadas'
          } else if(ids_horas_eliminadas.length === 0) {
            icono = 'error'
            titulo = '¡Error!'
            mensaje = 'Ninguna hora fue eliminada'
          } else {
            icono = 'warning'
            titulo = '¡Atención!'
            mensaje = `Se eliminaron las horas con código [${ids_horas_eliminadas.join(', ')}]  
            y no se eliminaron las horas con código [${ids_horas_no_eliminadas.join(', ')}]
            `
          }
          this.loadRows()
          this.$swal.fire({
            position: 'center',
            icon: icono,
            title: titulo,
            text: mensaje,
            showConfirmButton: true,
          });
      }).catch(error => {
          console.log(error);
      })      
    }
  }
}
</script>

<template>
<div>
    <div>
        <div class="ibox sombra-light">
            <div class="ibox-title">
                <h5>
                    <i class="fal fa-clock"></i> Gestión de horas
                </h5>
            </div>
            <div class="ibox-content">
                <div class=" mt-3">
                    <!-- Filtros -->
                    <div class="row">
                      <div class="col-md-3">
                        <DatePicker
                          v-model="fecha_inicio"
                          format="DD-MM-YYYY"
                          title="Fecha inicio"
                          placeholder="Fecha inicio"
                        />
                      </div>
                      <div class="col-md-3">
                        <DatePicker
                          v-model="fecha_termino"
                          format="DD-MM-YYYY"
                          title="Fecha término"
                          placeholder="Fecha término"
                        />
                      </div>
                      <div class="col-md-3">
                        <TextInput 
                          v-model="uuid"
                          title="Código cita"
                          placeholder="Código cita"
                        />
                      </div>
                      <div class="col-md-3">
                        <TextInput 
                          v-model="carga_id"
                          title="Código carga"
                          placeholder="Código carga"
                        />
                      </div>
                      <div class="col-md-4">
                        <Selector 
                          title="Establecimiento"
                          placeholder="Establecimiento"
                          v-model="id_establecimiento"
                          :options="establecimientos_options"
                          clearable
                        />
                      </div>
                      <div class="col-md-4">
                        <TextInput 
                          v-model="documento_paciente"
                          title="Documento paciente"
                          placeholder="Documento paciente"
                        />
                      </div>

                      <div class="col-md-4">
                        <TextInput 
                          v-model="nombre_profesional"
                          title="Nombre profesional"
                          placeholder="Nombre profesional"
                        />
                      </div>
                      <div class="col-md-4">
                        <TextInput
                          v-model="documento_profesional"
                          title="Documento profesional"
                          placeholder="Documento profesional"
                        />
                      </div>
                      <div class="col-md-4">
                        <Selector 
                          title="Tipo cita"
                          placeholder="Tipo cita"
                          v-model="id_tipo_cita"
                          :options="tipos_citas_options"
                          clearable
                        />
                      </div>
                      <div class="col-md-4">
                        <Selector 
                          title="Estado"
                          placeholder="Estado"
                          v-model="id_estado"
                          :options="estados_options"
                          clearable
                        />
                      </div>
                      <div class="col-md-4">
                        <button 
                          type="button"
                          class="btn btn-primary btn-block"
                          style="margin-top: 27.5px; height: 32.78px;"
                          @click="handleBuscarClick"
                        >Buscar
                        </button>
                      </div>
                    </div>
                    <!-- Acciones masivas -->
                    <div class="row mt-3">
                      <div class="col-md-4" v-if="can('horas.anular')">
                        <button class="btn btn-warning btn-block" @click="handleAnularClick">
                          Anular
                        </button>
                      </div>
                      <div class="col-md-4" v-if="can('horas.eliminar')">
                        <button class="btn btn-danger btn-block" @click="handleEliminarClick">
                          Eliminar
                        </button>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-md-12">
                        <ServerSideDatatable
                          ref="tableRef" 
                          :table-headers="tableHeaders"
                          :fetch-config="{
                            url: '/admin/configurar/horas/buscar',
                            params: fetchParams,
                          }"
                          :csvAction="{
                            isActive: true,
                            baseURL: csv_action,
                            params: fetchParams,
                          }"
                          :disableActions="true"
                          :disableRequestOnMounted="true"
                          @changeSelectedRows="ids_horas_seleccionadas = $event"
                          rowKey="id"
                        >
                          <!-- afterRequest: afterRequest, -->
                          <!-- @changeIsLoadingData="setAreLoadingCitas($event)" -->
                          <!-- @changeData="setCitas($event)" -->
                          <template v-slot:actions="{ row: cita }">
                              <OpcionesButton :cita="cita" />
                          </template>

                          <!-- Columns -->
                          <template v-slot:column-uuid="{row}">
                            <span v-if="row.UUID">{{ row.UUID }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-carga_id="{row}">
                            <span v-if="row.carga_id">{{ row.carga_id }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-establecimiento="{row}">
                            <span v-if="row.nombre_establecimiento">{{ row.nombre_establecimiento }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-estado="{row}">
                            <span v-if="row.nombre_estado">{{ row.nombre_estado }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-fecha_inicio="{row}">
                            <span v-if="row.hora_inicio">{{ row.hora_inicio }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-nombre_profesional="{row}">
                            <span v-if="row.nombre_profesional">{{ row.nombre_profesional }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>

                          <template v-slot:column-rut_profesional="{row}">
                            <span v-if="row.rut_profesional">{{ row.rut_profesional }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>



                          <template v-slot:column-nombre_paciente="{row}">
                            <span v-if="row.nombre_paciente">{{ row.nombre_paciente }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>

                                                     <template v-slot:column-rut_paciente="{row}">
                            <span v-if="row.rut_paciente">{{ row.rut_paciente }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-tipo_cita="{row}">
                            <span v-if="row.nombre_tipo_cita">{{ row.nombre_tipo_cita }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>       

                          <template v-slot:column-tipo_atencion="{row}">
                            <span v-if="row.tipo_atencion">{{ row.tipo_atencion }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>                                       
                        </ServerSideDatatable>                      
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>